import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { FlatButton } from 'material-ui'
import cx from 'classnames'

import EditorHeader from '../EditorHeader'
import EmailBodyEditor from '../EmailBodyEditor'
import PlainTextEditor from '../PlainTextEditor'
import ReminderCheckbox from '../ReminderCheckbox'
import characterCountMessage from '../../../services/character-count'

import styles from '../styles/SettingEditor'
import css from './styles.css'

class SettingTextEditor extends Component {
  static propTypes = {
    bodyState: PropTypes.shape({
      getCurrentContent: PropTypes.func.isRequired,
    }),
    handleCheckbox: PropTypes.func,
    handleDelete: PropTypes.func.isRequired,
    handleDiscard: PropTypes.func.isRequired,
    handleSave: PropTypes.func.isRequired,
    hasMoved: PropTypes.bool,
    isEmail: PropTypes.bool,
    isReminder: PropTypes.bool,
    maxChars: PropTypes.number,
    setting: PropTypes.shape({
      id: PropTypes.number,
    }),
    subjectState: PropTypes.shape({
      getCurrentContent: PropTypes.func.isRequired,
    }),
    updateBodyState: PropTypes.func.isRequired,
    updateSubjectState: PropTypes.func.isRequired,
  }

  state = {
    checkboxChanged: false,
    oldBodyState: this.props.bodyState.getCurrentContent(),
    oldSubjectState: this.props.isEmail
      ? this.props.subjectState.getCurrentContent()
      : false,
    textChange: false,
  }

  bodyUpdate = newEditorState => {
    const { updateBodyState } = this.props
    const { textChange, oldBodyState } = this.state
    const newBodyState = newEditorState.getCurrentContent()
    const textChanged = oldBodyState !== newBodyState
    if (textChanged && !textChange) {
      this.setState({ textChange: textChanged })
    }
    updateBodyState(newEditorState)
  }

  subjectUpdate = newEditorState => {
    const { updateSubjectState } = this.props
    const { textChange, oldSubjectState } = this.state
    const newSubjectState = newEditorState.getCurrentContent()
    const subjectChanged = oldSubjectState !== newSubjectState
    if (subjectChanged && !textChange) {
      this.setState({ textChange: subjectChanged })
    }
    updateSubjectState(newEditorState)
  }

  interceptCheckboxClick = () => {
    const { handleCheckbox } = this.props
    const { checkboxChanged } = this.state
    this.setState({ checkboxChanged: !checkboxChanged }, handleCheckbox)
  }

  render() {
    const {
      bodyState,
      handleDelete,
      handleDiscard,
      handleSave,
      hasMoved,
      isEmail,
      isPostAppt,
      isReminder,
      setting,
      subjectState,
      maxChars,
    } = this.props
    const { id: settingId } = setting
    const { checkboxChanged, textChange } = this.state

    const notTemplate = false

    const containerStyles = !isEmail
      ? styles.container
      : Object.assign({}, styles.container, styles.richContainer)

    const messageEmpty = isEmail
      ? !bodyState.getCurrentContent().hasText() ||
        !subjectState.getCurrentContent().hasText()
      : !bodyState.getCurrentContent().hasText()

    const messageChanged = textChange || hasMoved || checkboxChanged
    const textSettingStyles = isEmail ? '' : 'textSettingEditor'
    const characterCount = bodyState.getCurrentContent().getPlainText().length
    const approachingMaxChars = characterCount > maxChars - 20 && !isEmail
    const exceedsMaxChars = characterCount > maxChars && !isEmail
    const saveDisabled = messageEmpty || !messageChanged || exceedsMaxChars

    const charCountCss = cx(css.characterCount, {
      [css.approachingMaxChars]: approachingMaxChars,
      [css.exceedsMaxChars]: exceedsMaxChars,
    })

    return (
      <div
        className={`CallTextSettingEditor ${textSettingStyles}`}
        style={containerStyles}
      >
        <EditorHeader {...this.props} />
        {settingId && (
          <div
            className={css.buttonDiscard}
            onClick={handleDiscard}
            role="button"
            tabIndex={0}
          />
        )}
        <div style={{ marginBottom: '7px' }}>
          <span style={{ fontSize: 13 }}>Message</span>
        </div>
        <PlainTextEditor
          {...this.props}
          updateBodyState={this.bodyUpdate}
          updateSubjectState={this.subjectUpdate}
        />
        {isEmail && (
          <EmailBodyEditor {...this.props} updateBodyState={this.bodyUpdate} />
        )}

        <div className="button-area" style={styles.buttonArea}>
          {(isReminder || isPostAppt) && (
            <ReminderCheckbox
              {...this.props}
              handleCheckboxClick={this.interceptCheckboxClick}
            />
          )}
          <FlatButton
            label="Delete"
            secondary
            style={styles.button_secondary}
            onClick={handleDelete}
            labelStyle={{ fontWeight: 'normal' }}
          />
          <FlatButton
            label="Save"
            primary
            style={styles.button_primary}
            onClick={() => handleSave(notTemplate)}
            labelStyle={{ fontWeight: 'bold', letterSpacing: '0.5px' }}
            disabled={saveDisabled}
          />
        </div>
        {!isEmail && characterCount > 0 && (
          <div className={charCountCss}>
            {characterCountMessage(characterCount, maxChars, true)}
          </div>
        )}
      </div>
    )
  }
}

export default SettingTextEditor



// WEBPACK FOOTER //
// ./src/components/Settings/SettingTextEditor/index.js